// extracted by mini-css-extract-plugin
export var listContainer = "Publications-module--listContainer--8286f";
export var listItem = "Publications-module--listItem--bdaf4";